// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__rtr_s","loader":"Loader_loader___rb1F","load5":"Loader_load5__XdE2p","text":"Loader_text__tEhvj"};